// GeburtsdatumPickerv2.js
import React, { useEffect, useState } from 'react';
import { Box, TextField } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { deDE } from '@mui/x-date-pickers/locales';
import dayjs from 'dayjs';
import 'dayjs/locale/de';

dayjs.locale('de');

export default function GeburtsdatumPickerv2() {
  // get initial value from PHP container
  const initialValue = (() => {
    const root = document.getElementById('geburtsdatum-root-v2');
    const date = root?.dataset.date;
    return date ? dayjs(date, 'DD.MM.YYYY') : null;
  })();

  const [value, setValue] = useState(initialValue);

  // keep PHP hidden input updated
  useEffect(() => {
    const hiddenInput = document.querySelector('#geburtsdatum');
    if (hiddenInput) {
      hiddenInput.value = value ? value.format('DD.MM.YYYY') : '';
    }
  }, [value]);

  return (
    <LocalizationProvider
      dateAdapter={AdapterDayjs}
      adapterLocale="de"
      localeText={deDE.components.MuiLocalizationProvider.defaultProps.localeText}
    >
      <Box sx={{ width: '100%' }}>
        <DatePicker
          value={value}
          onChange={(newValue) => setValue(newValue)}
          format="DD.MM.YYYY"
          disableFuture
          slotProps={{
            textField: {
              fullWidth: true,
              variant: 'outlined',
              placeholder: 'TT.MM.JJJJ',
              required: true,
              className: 'geburtsdatum',
              inputProps: {
                inputMode: 'none',
                readOnly: true, // prevents typing, picker only
              },
            },
          }}
          renderInput={(params) => <TextField {...params} />}
        />
      </Box>
    </LocalizationProvider>
  );
}
